<template>
<div v-if='items.length'>
  <h6>Select a field to see history:</h6>
  <b-form-checkbox-group buttons button-variant="outline-secondary" size='sm' id="layer-tags" v-model="selectedFields" :options="fields">
  </b-form-checkbox-group>
  <div v-if='selectedFields.length > 1'>
    <b-table small hover bordered responsive :per-page="perPage" :current-page="currentPage" :fields="selectedFields" :items="filteredItems ">
    </b-table>
    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0 pagination-or" />
  </div>
</div>
<div v-else>
  <h6>No history for this feature type at this given time</h6>
</div>
</template>

<script>
export default {
  name: 'info-history',
  data() {
    return {
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      fields: [],
      items: [],
      filteredItems: [],
      selectedFields: ['change_date']
    }
  },
  computed: {
    feature() {
      return this.$store.getters['map/currentInfoItem']
    }
  },
  methods: {
    loadHistory(val) {
      if (val && val.id) {
        if (val['centreline_type']) {
          this.$http.get('/api/layers/centreline-history', {
              params: {
                id: val['id']
              }
            })
            .then(res => {
              this.extractData(res.body)
            }, res => {})
        }
        else if (val['well_type']) {
          this.$http.get('/api/layers/well-history', {
              params: {
                id: val['id']
              }
            })
            .then(res => {
              this.extractData(res.body)
            }, res => {})
        } else {
          this.items = []
          this.fields = []
          this.currentPage = 1
        }
      }

    },
    extractData(data) {
      let c = {}
      let items = []
      data.filter(d => d.changes).forEach(d => {
        for (let k in d.changes) {
          if (d.changes.hasOwnProperty(k)) {
            c[k] = true
          }
        }

        let i = d.changes
        Object.keys(i).forEach((key) => {
          if (i[key] == null) {
            i[key] = 'Null'
          }
        })
        if (Object.keys(i).length === 0 && i.constructor === Object) {
          return
        } else {
          i['change_date'] = d.change_date
          items.push(i)
        }
      })
      let fields = Object.keys(c)

      var index = fields.indexOf('change_date');
      if (index !== -1) fields.splice(index, 1);

      this.fields = fields
      this.items = items

      this.currentPage = 1

    }
  },
  watch: {
    feature(val) {
      if (val) {
        this.filteredItems = []
        this.selectedFields = ['change_date']
        this.loadHistory(val)
      }
    },
    selectedFields(val) {
      this.filteredItems = []
      val.forEach(f => {
        if (f !== 'change_date') {
          let list = this.items.filter(i => Object.keys(i).indexOf(f) > -1)
          this.filteredItems = this.filteredItems.concat(list)
          this.totalRows = this.filteredItems.length
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/map/info/InfoHistory.vue